var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import styled, { useTheme } from "styled-components";
import { Box } from "../Box";
import { Flex } from "../Flex";
import { Text } from "../Text";
import { Icon } from "../Icon";
/**
 * The `Card` component is a wrapper component that provides a consistent look and feel for all cards in the application.
 * We forward the ref to the underlying `Box` component so that the card can be used as a parent component for other components.
 */
export const Card = forwardRef((props, ref) => {
    const { colors: { cardColors }, } = useTheme();
    return (React.createElement(StyledCard, Object.assign({ as: "section", "data-testid": "card", bg: cardColors.cardBackground, border: 1, borderColor: cardColors.cardBorder, ref: ref }, props)));
});
const StyledCard = styled(Box) `
  /* Allow children to inherit the Card's border radius */
  --card-border-radius: ${({ theme }) => theme.radii[1]};

  border-radius: var(--card-border-radius, "0px");
`;
export const CardHeader = (props) => (React.createElement(Flex, Object.assign({ as: "h2", m: 0, fontWeight: "normal", px: "12px", py: 1, alignItems: "center" }, props)));
export const CardHeading = (_a) => {
    var { children, count, iconSrc } = _a, rest = __rest(_a, ["children", "count", "iconSrc"]);
    const { colors: { cardColors }, } = useTheme();
    return (React.createElement(Flex, Object.assign({}, rest, { alignItems: "center", "data-testid": "CardHeading" }),
        iconSrc && (React.createElement(Box, { mr: 2, color: cardColors.cardIcon, height: "20px" },
            React.createElement(Icon, { src: iconSrc, size: 20 }))),
        React.createElement(Text, { as: "span", textStyle: "cardHeading", "data-testid": "CardHeadingText" },
            count !== undefined && count !== "" && (React.createElement(Text, { as: "span", "data-testid": "CardHeadingCount", textStyle: "cardHeadingCount", mr: 2 }, count)),
            children)));
};
export const CardBody = (props) => React.createElement(Box, Object.assign({ p: "12px" }, props));
